import type { SocialMediaType } from '@/app/types/social-media';
import { isInAppBrowser } from '@/app/utils/browser';

export const createShareUrl = (type: SocialMediaType, url: string) => {
  switch (type) {
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    case 'line':
      return `https://line.me/R/msg/text/?${encodeURIComponent(url)}`;
    default:
      return '';
  }
};

export const openShareUrl = (shareUrl: string) => {
  if (!shareUrl) return;

  if (isInAppBrowser()) {
    window.location.assign(shareUrl);
    return;
  }

  const openedWindow = window.open(shareUrl, '_blank');

  if (!openedWindow) {
    window.location.assign(shareUrl);
    return;
  }

  try {
    openedWindow.opener = null;
  } catch {
    // Some WebViews expose a restricted window proxy after opening.
  }
};

const CANCELLED_ERROR_NAMES = ['abort', 'notallowed'];
const CANCELLED_ERROR_MESSAGES = ['cancel', 'denied'];
const ABORT_ERROR_CODE = 20;

export const wasShareCancelled = (error: unknown) => {
  if (!error || typeof error !== 'object') return false;

  const { name, message, code } = error as Partial<DOMException>;
  const normalizedName = typeof name === 'string' ? name.toLowerCase() : '';
  const normalizedMessage =
    typeof message === 'string' ? message.toLowerCase() : '';

  return (
    CANCELLED_ERROR_NAMES.some((token) => normalizedName.includes(token)) ||
    CANCELLED_ERROR_MESSAGES.some((token) =>
      normalizedMessage.includes(token)
    ) ||
    code === ABORT_ERROR_CODE
  );
};
